import { render } from "./ChatModal.vue?vue&type=template&id=0c60a288&scoped=true"
import script from "./ChatModal.vue?vue&type=script&lang=js"
export * from "./ChatModal.vue?vue&type=script&lang=js"

import "./ChatModal.vue?vue&type=style&index=0&id=0c60a288&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c60a288"],['__file',"webpack-assets/vue/templates/chat/parts/ChatModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c60a288"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c60a288', __exports__)) {
    api.reload('0c60a288', __exports__)
  }
  
  module.hot.accept("./ChatModal.vue?vue&type=template&id=0c60a288&scoped=true", () => {
    api.rerender('0c60a288', render)
  })

}


export default __exports__